import * as actiontypes from '../types';
import axios from 'axios';
import {
  SET_KELLY_BLUE_BOOK_SUCCESS,
  SET_KELLY_BLUE_BOOK_VIN_DATA,
  SET_KELLY_BLUE_BOOK_WITHOUT_VIN_MODEL_YEAR_ID,
  SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MAKE,
  SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MODEL,
  SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_VEHICLE_DATA,
  SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_YEAR,
  SET_KELLY_BLUE_BOOK_WITH_VIN_DETAILS,
  SET_KELLY_BLUE_BOOK_CURRENT_STEP_NAME,
  SHOW_KBB_TRADE_BUTTONS,
  SET_KELLY_BLUE_BOOK_WITH_VIN_MORE_VEHICLES_WITH_VIN,
  SET_KELLY_SELECTED_VEHICLE_DETAILS,
  GUARANTEED_TRADE_IN_RESPONSE,
  GUARANTEED_TRADE_IN_VIN,
} from '../StoreConstants/KellyBlueBookConstants';
function defaultKnowMyVinToggle() {
  if (window?.userDetails?.consumerid) {
    return true;
  } else {
    return window.defaultToKnowMyVIN;
  }
}
export const MyTradeValuePageDetails = {
  state: {
    gtpSkipTradePage: false,
    gtpStatusList: ['Permanently Excluded', 'Excluded'],
    gtpActiveStatus: 'Active',
    gtpGenericMessage: 'Sorry, your vehicle is not eligible for the Guaranteed Trade-In Program.',
    showLoader: false,
    gtpErrorMessage: '',
    gtpMake: 'subaru',
    gtpSkip: false,
    enableGTPSubaruMake: false,
    blackBookSelectedMake: '',
    tradePageCurrentStepName: 'Select Vehicle',
    guaranteedTradeInResponse: '',
    guaranteedTradeInVin: '',
    tradeAppraisalAndScheduleTime: {
      selectedDate: '',
      Comments: '',
      sendAppraisal: true,
    },
    logLeadPayload: {},
    dealerEmailPayload: {},
    clientEmailPayload: {},
    showkbbtradebuttons: true,
    currentStepName: 'Select Vehicle',
    currentstep: 1,
    first_time: true,
    tradeSubmitted: false,
    issearchbyvin: defaultKnowMyVinToggle(),
    isbackclicked: false,
    vinfilterdata: {
      vin: '',
      condition: 'average',
      mileage: '',
    },
    blackbookfilterdata: {
      year: '',
      make: '',
      model: '',
      trim: '',
      style: '',
      miles: '',
    },
    vehicledetails: {
      tradeValue: '',
      year: '',
      make: '',
      model: '',
      trim: '',
      condition: 'average',
      miles: '',
      imgUrl: '',
      vin: '',
    },
    contactinfo: {
      FirstName: '',
      LastName: '',
      EmailAddress: '',
      PhoneNumber: '',
    },
    vehicleIntrest: {
      year: '',
      make: '',
      model: '',
      trim: '',
    },
    kellyBlueBookVinData: '',
    kellySelectedVehicleDetails: '',
    loginVinFound: false,
    kellyBlueBookWithVin: '',
    kellyBlueBookSuccess: false,
    kellyBlueBookMoreVehiclesWithVin: '',
    kellyBlueBookWithoutVin: {
      currentStep: 1,
      selectedYear: '',
      selectedMake: '',
      selectedModel: '',
      selectedTrim: '',
      selectedMiles: '',
      selectedColor: '',
      selectedCondition: '',
      selectedVehicleOptionIds: [],
      selectedZipCode: '',
      selectedModelYearId: '',
      selectedVehicleId: '',
      modelYearsIds: [],
      selectedTrimName: '',
      loginVinFound: false,
      selectedModelName: '',
      selectedMakeName: '',
    },
  },
  getters: {
    [actiontypes.IS_GTP_PROCESS]: (state) => {
      let path = window.location.pathname;
      let isTradePage = path.includes('mytradevalue');
      let gtpKip = state.gtpSkip;
      if (isTradePage) {
        gtpKip = state.gtpSkipTradePage;
      }
      let make = window.enableKbb
        ? state.kellyBlueBookWithoutVin.selectedMakeName
        : state.blackBookSelectedMake;
      let enabled = false;
      if (
        window.enableGuaranteedTradeInProgram &&
        !gtpKip &&
        make.toLowerCase() === state.gtpMake
      ) {
        enabled = true;
      }

      return enabled;
    },
    [actiontypes.GTP_VIN_STATUS_MESSAGE](state) {
      let message = '';
      if (window.enableKbb) {
        let userEnteredMiles = state.kellyBlueBookWithoutVin.selectedMiles
          ? state.kellyBlueBookWithoutVin.selectedMiles
          : 0;
        let tradeInResponse = state.guaranteedTradeInResponse;
        if (
          state.gtpStatusList.includes(tradeInResponse.gtpStatus) ||
          +userEnteredMiles > +tradeInResponse.maxMiles
        ) {
          if (tradeInResponse.gtpExclusions && tradeInResponse.gtpExclusions.length > 0) {
            message = tradeInResponse.gtpExclusions[0].customerMessage;
          } else if (state.gtpStatusList.includes(tradeInResponse.gtpStatus)) {
            message = state.gtpGenericMessage;
          } else if (+userEnteredMiles > +tradeInResponse.maxMiles) {
            message = `Sorry, your vehicle is above the maximum mileage limits of ${this.tradeInResponse.maxMiles}. Please visit your participating Subaru retailer to receive a complimentary and complete vehicle evaluation to determine the actual market value of your Subaru vehicle.`;
          } else {
            message = state.gtpGenericMessage;
          }
        }
      }
      return message;
    },
  },
  mutations: {
    [actiontypes.GTP_SKIP_TRADE_PAGE](state, payload) {
      state.gtpSkipTradePage = payload;
    },
    [actiontypes.SHOW_LOADER](state, payload) {
      state.showLoader = payload;
    },
    [actiontypes.GTP_ERROR_MESSAGE](state, payload) {
      state.gtpErrorMessage = payload;
    },
    [actiontypes.GTP_SKIP](state, payload) {
      state.gtpSkip = payload;
    },
    [actiontypes.BLACK_BOOK_SELECTED_MAKE](state, payload) {
      state.blackBookSelectedMake = payload;
    },
    [actiontypes.SET_STEP_NAME](state, payload) {
      state.tradePageCurrentStepName = payload;
    },
    [GUARANTEED_TRADE_IN_RESPONSE](state, payload) {
      state.guaranteedTradeInResponse = payload;
    },
    [GUARANTEED_TRADE_IN_VIN](state, payload) {
      state.guaranteedTradeInVin = payload;
    },
    [SHOW_KBB_TRADE_BUTTONS](state, payload) {
      state.showkbbtradebuttons = payload;
    },

    [SET_KELLY_SELECTED_VEHICLE_DETAILS](state, payload) {
      state.kellySelectedVehicleDetails = payload;
    },
    [SET_KELLY_BLUE_BOOK_WITH_VIN_MORE_VEHICLES_WITH_VIN](state, payload) {
      state.kellyBlueBookMoreVehiclesWithVin = payload;
    },
    [SET_KELLY_BLUE_BOOK_CURRENT_STEP_NAME](state, payload) {
      state.currentStepName = payload;
    },
    [actiontypes.SET_BLACK_BOOK_FILTERS](state, filters) {
      state.blackbookfilterdata = filters;
    },
    [SET_KELLY_BLUE_BOOK_WITH_VIN_DETAILS](state, payload) {
      state.kellyBlueBookWithVin = payload;
    },
    [SET_KELLY_BLUE_BOOK_VIN_DATA](state, payload) {
      state.kellyBlueBookVinData = payload;
    },
    [SET_KELLY_BLUE_BOOK_SUCCESS](state, payload) {
      state.kellyBlueBookSuccess = payload;
    },
    [SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MODEL](state, payload) {
      state.kellyBlueBookWithoutVin.selectedModel = payload;
    },
    [SET_KELLY_BLUE_BOOK_WITHOUT_VIN_MODEL_YEAR_ID](state, payload) {
      state.kellyBlueBookWithoutVin.modelYearsIds = payload;
    },

    [SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MAKE](state, payload) {
      state.kellyBlueBookWithoutVin.selectedMake = payload;
    },
    [SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_YEAR](state, payload) {
      state.kellyBlueBookWithoutVin.selectedYear = payload;
    },
    [SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_VEHICLE_DATA](state, payload) {
      state.kellyBlueBookWithoutVin[payload.key] = payload.value;
    },
    [actiontypes.SET_VIN_FILTERS](state, filters) {
      state.vinfilterdata = filters;
    },
    [actiontypes.SET_CURRENT_STEP](state, currentstep) {
      state.currentstep = currentstep;
    },
    [actiontypes.ON_MY_TRADE_BACK_BTN_CLICKED](state, searchtype) {
      state.isbackclicked = searchtype;
    },
    [actiontypes.SET_TRADE_SEARCH_TYPE](state, searchtype) {
      state.issearchbyvin = searchtype;
    },
    [actiontypes.DECREMENT_TRADE_VALUE_STEP](state) {
      if (state.currentstep !== 1) {
        state.currentstep = state.currentstep - 1;
      }
    },
    [actiontypes.INCREMENT_TRADE_VALUE_STEP](state) {
      state.currentstep++;
    },
    [actiontypes.SET_VEHICLE_DATA](state, payload) {
      state.vehicledetails = payload;
    },
    [actiontypes.FIRST_CALL](state, payload) {
      state.first_time = payload;
    },
    [actiontypes.VALUE_MYTRADE_SUBMIT](state) {
      state.tradeSubmitted = true;
    },
    [actiontypes.CONTACT_INFO](state, payload) {
      state.contactinfo = payload;
    },
    [actiontypes.SET_VEHICLE_INTREST](state, payload) {
      state.vehicleIntrest = { ...payload };
    },
    [actiontypes.SET_TRADE_SEARCH_TYPE](state, searchtype) {
      state.issearchbyvin = searchtype;
      if (searchtype === true) {
        // Clear
        state.kellyBlueBookWithoutVin = {
          currentStep: 1,
          selectedYear: '',
          selectedMake: '',
          selectedModel: '',
          selectedTrim: '',
          selectedMiles: '',
          selectedColor: '',
          selectedCondition: '',
          selectedVehicleOptionIds: [],
          selectedZipCode: '',
          selectedModelYearId: '',
          selectedVehicleId: '',
          modelYearsIds: [],
          selectedTrimName: '',
          loginVinFound: false,
          selectedModelName: '',
          selectedMakeName: '',
        };
      }
    },
    [actiontypes.VALUE_MY_TRADE_LOG_LEAD_PAYLOAD](state, payload) {
      state.logLeadPayload = payload;
    },
    [actiontypes.VALUE_MY_TRADE_DEALER_EMAIL_PAYLOAD](state, payload) {
      state.dealerEmailPayload = payload;
    },
    [actiontypes.VALUE_MY_TRADE_CLIENT_EMAIL_PAYLOAD](state, payload) {
      state.clientEmailPayload = payload;
    },
    [actiontypes.TRADE_APPRAISAL_AND_SCHEDULE_TIME](state, payload) {
      state.tradeAppraisalAndScheduleTime = payload;
    },
  },
  actions: {
    async [actiontypes.GET_BLACKBOOK_DATA](context, payload) {
      let searchKey = '';

      searchKey += context.state.blackbookfilterdata.year
        ? context.state.blackbookfilterdata.year + '@'
        : '';
      searchKey += '';
      searchKey += context.state.blackbookfilterdata.make
        ? context.state.blackbookfilterdata.make + '@'
        : '';
      searchKey += '';

      searchKey += context.state.blackbookfilterdata.model
        ? context.state.blackbookfilterdata.model + '@'
        : '';
      searchKey += '';
      searchKey += context.state.blackbookfilterdata.trim
        ? context.state.blackbookfilterdata.trim + '@'
        : '';
      searchKey += '';
      searchKey += context.state.blackbookfilterdata.styleId
        ? context.state.blackbookfilterdata.styleId + '@'
        : '';
      let response = '';
      let isVin = window.isauthenticated === 'True';
      let consumerId = window.isauthenticated === 'True' ? window.userDetails.consumerid : '';
      if (searchKey !== '') {
        searchKey = searchKey.substring(0, searchKey.length - 1);
      }

      let accountId =
        window.accountId === '59823' || window.accountId === '60175' ? '43440' : window.accountId;
      response = await axios.get(
        `${window.ApiBaseUrl}/ShopperService/mytradevalue?isVin=${isVin}&consumerId=${consumerId}&key=${searchKey}&accountId=${accountId}&condition=average&mileage=${payload}`
      );

      if (response) {
        this.showLoading = false;
        if (response.data) {
          context.commit(actiontypes.SET_VEHICLE_DATA, response.data);
        }
      }
    },
  },
};
